export default ['FR','EN']
